/**
 * ApplyPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Row,
  Col,
  Text,
  InputFormTable,
  Title,
  Button,
} from 'components';
import { Input } from 'antd';
import { openAddressModal } from 'utils/DaumAPIManager';

const ApplyPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { nameRef, contentRef, inputValue, setInputValue, onSubmit, onChange } =
    props;

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    subTitle: {
      fontSize: 17,
      fontWeight: 500,
      lineHeight: '141%',
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
    linkButton: {
      border: 'none',
      background: 'none',
      fontSize: 12,
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  };

  const form = [
    {
      label: '브랜드명',
      required: true,
      form: [
        {
          input: (
            <Input
              ref={nameRef}
              size="large"
              value={inputValue.shop_information_name}
              onChange={(e) =>
                onChange(
                  'shop_information_name',
                  e.target.value,
                  inputValue,
                  setInputValue
                )
              }
              placeholder="브랜드명을 입력해주세요"
              showCount
              count={{
                max: 20,
                show: true,
              }}
              style={{ ...styles.form.input.large, width: 500 }}
            />
          ),
        },
      ],
    },
    {
      label: '브랜드 설명',
      required: true,
      form: [
        {
          input: (
            <Input.TextArea
              ref={contentRef}
              size="large"
              value={inputValue.shop_information_content}
              onChange={(e) =>
                onChange(
                  'shop_information_content',
                  e.target.value,
                  inputValue,
                  setInputValue
                )
              }
              placeholder="브랜드 설명을 입력해주세요"
              showCount
              count={{
                max: 100,
                show: true,
              }}
              style={{ ...styles.form.input.large, width: 500 }}
            />
          ),
        },
      ],
    },
    {
      label: '주소',
      required: true,
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                value={inputValue.shop_information_address}
                placeholder="주소"
                readOnly
                style={{ width: 300 }}
              />
              <Button size="large" onClick={() => handleOpen()}>
                주소찾기
              </Button>
            </>
          ),
        },
        {
          input: (
            <>
              <Input
                size="large"
                value={inputValue.shop_information_address_detail}
                onChange={(e) =>
                  onChange(
                    'shop_information_address_detail',
                    e.target.value,
                    inputValue,
                    setInputValue
                  )
                }
                placeholder="상세주소"
                style={{ width: 500 }}
              />
            </>
          ),
        },
      ],
    },
  ];
  /* ===== FUNCTION ===== */
  const handleOpen = () => {
    openAddressModal((res) =>
      onChange(
        'shop_information_address',
        res.address,
        inputValue,
        setInputValue
      )
    );
  };
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={800} padding={20} minHeight={'100vh'}>
      <Row>
        <Col x={24}>
          <Content maxWidth={'100%'} padding={0}>
            <Text
              size={30}
              style={{
                fontFamily: `'Dela Gothic One', sans-serif`,
                margin: '30px 0px',
              }}
              align={'center'}
            >
              JM COFFEE 관리자 시스템
            </Text>
            <Title style={{ ...styles.subTitle }}>쇼핑몰 정보</Title>
            <InputFormTable form={form} />

            <Content
              maxWidth={'100%'}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 20,
              }}
            >
              <Button
                size="large"
                style={{ width: '50%' }}
                onClick={() => onSubmit()}
              >
                등록하기
              </Button>
            </Content>
          </Content>
        </Col>
      </Row>
    </Content>
  );
};

export default ApplyPresenter;
